import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {ThemeReferentiel} from "@common/model/theme-ref.enum";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private currentThemeSubject: BehaviorSubject<ThemeReferentiel> = new BehaviorSubject<ThemeReferentiel>(ThemeReferentiel.Default);
  public currentTheme: Observable<ThemeReferentiel> = this.currentThemeSubject.asObservable();

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    const savedTheme = localStorage.getItem('appTheme') as ThemeReferentiel;
    this.setTheme(savedTheme || ThemeReferentiel.Default);
  }

  setTheme(theme: ThemeReferentiel): void {

    Object.values(ThemeReferentiel).forEach(t => {
      const oldThemeClass = `theme-${t.toLowerCase().replace(/\s/g, '-')}`;
      this.renderer.removeClass(document.body, oldThemeClass);
    });

    const newThemeClass = `theme-${theme.toLowerCase().replace(/\s/g, '-')}`;
    this.renderer.addClass(document.body, newThemeClass);

    this.currentThemeSubject.next(theme);
    localStorage.setItem('appTheme', theme);
  }

  getTheme(): Observable<ThemeReferentiel> {
    return this.currentTheme;
  }
}
